var exports = {
  "n": "xcc377c0b--717679--row",
};

module.exports = exports;
